import ENDPOINTS from '../../constants/apiEndPoints';
import {RoleFormPayload} from '../../pages/users/components/RoleScreens/components/AddEditRoleDialog';
import {
  GroupedRolesResponse,
  RoleQueryParams,
  RolesListResponse,
  SingleRoleResponse,
} from '../../pages/users/components/RoleScreens/roles';
import {ApiResponse, axiosInstance} from '../axiosInstance';

export const handleCreateRoleService = async (payload: RoleFormPayload) => {
  const response = await axiosInstance.post(ENDPOINTS.GET_CREATE_ROLE, payload);
  return response?.data;
};

export const handleGetAllRolesService = async (
  params: RoleQueryParams,
): Promise<ApiResponse<RolesListResponse>> => {
  const response = await axiosInstance.get(ENDPOINTS.GET_CREATE_ROLE, {params});
  return response?.data;
};

export const handleGetGroupedRolesService = async (
  params: Omit<RoleQueryParams, 'page' | 'limit' | 'grouped'> & {
    clientIds: string[];
  },
): Promise<ApiResponse<GroupedRolesResponse>> => {
  const response = await axiosInstance.get(ENDPOINTS.GET_CREATE_ROLE, {
    params: {...params, grouped: true},
  });
  return response?.data;
};

export const handleGetSingleRolService = async (
  id: string,
): Promise<ApiResponse<SingleRoleResponse>> => {
  const response = await axiosInstance.get(
    ENDPOINTS.GET_UPDATE_DELETE_ROLE(id),
  );
  return response?.data;
};

export const handleUpdateRoleService = async (
  id: string,
  payload: RoleFormPayload,
) => {
  const response = await axiosInstance.put(
    ENDPOINTS.GET_UPDATE_DELETE_ROLE(id),
    payload,
  );
  return response?.data;
};

export const handleDeleteRoleService = async (id: string) => {
  const response = await axiosInstance.delete(
    ENDPOINTS.GET_UPDATE_DELETE_ROLE(id),
  );
  return response?.data;
};
